<template>
  <div class="Buscar">
    <Menu :sesion="sesion" :url="url" v-if="sesion" />
    <Submenu :menuActivo="0" :url="url" />
    
    <div class="container-fluid pt-3">
      <router-link to="/Buscar">
          <font-icon icon="arrow-circle-left" />
          Regresar
      </router-link>

      <Proyecto class="pt-2 pb-3" :idProyecto="idProyecto" />
      
      <div class="row">
        <div class="offset-sm-8 col-sm-4">
          <NuevaPropuesta :idProyecto="idProyecto"/>
        </div>
      </div>

      <div class="pt-3">
        <Blog :id=idProyecto />
      </div>

    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'

import Submenu from "@/components/Submenu";
import Menu from "@/components/Menu";
import Proyecto from '@/components/Proyecto'
import Blog from '@/components/Blog'
import NuevaPropuesta from '@/components/NuevaPropuesta'

export default {
name: "Buscar",
components: {Submenu,Menu,Proyecto,Blog,NuevaPropuesta},
mixins: [ globalFunctions ],
data() {
  return {
    sesion: false,
    status: false,
    rol: localStorage.rol,
    idProyecto: this.$route.params.id
  };
},
computed:{
  ...mapState(['url'])
},
mounted() {
  //check user
  let resp = this.checkUser();
  this.sesion = resp;
},
};
</script>


<style scoped>
.spinner-border{
  color: #ff200b;
}

.bandera-star .star{
  margin-right: -15px;
}

.bandera-star .bandera{
  text-align: right;
  margin-right: -80px;
  margin-top: 3px;
}

.mensaje-post{
  margin-top: 150px;
  margin-bottom: 150px;
}

.card-header, .card-footer{
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// src/views/Detalle/Detalle.vue